module.exports = __webpack_public_path__ + "img/patMobile.2d2356b6.png";